// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/accounts/v1/accounts.proto" (package "c1.api.accounts.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message c1.api.accounts.v1.ListAuthBackendsRequest
 */
export interface ListAuthBackendsRequest {
}
/**
 * @generated from protobuf message c1.api.accounts.v1.ListAuthBackendsResponse
 */
export interface ListAuthBackendsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accounts.v1.AuthBackends auth_backends = 1;
     */
    authBackends: AuthBackends[];
}
/**
 * @generated from protobuf message c1.api.accounts.v1.GetInstallationRequest
 */
export interface GetInstallationRequest {
}
/**
 * @generated from protobuf message c1.api.accounts.v1.GetTenantRequest
 */
export interface GetTenantRequest {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
}
/**
 * @generated from protobuf message c1.api.accounts.v1.Installation
 */
export interface Installation {
    /**
     * @generated from protobuf field: string domain = 1;
     */
    domain: string;
    /**
     * @generated from protobuf field: uint32 port = 2;
     */
    port: number;
    /**
     * @generated from protobuf field: string accounts_domain = 3;
     */
    accountsDomain: string;
    /**
     * @generated from protobuf field: uint32 accounts_port = 4;
     */
    accountsPort: number;
}
/**
 * @generated from protobuf message c1.api.accounts.v1.Tenant
 */
export interface Tenant {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string domain = 2;
     */
    domain: string;
    /**
     * @generated from protobuf field: string display_name = 3;
     */
    displayName: string;
    /**
     * @generated from protobuf field: c1.api.accounts.v1.Installation installation = 4;
     */
    installation?: Installation;
}
/**
 * @generated from protobuf message c1.api.accounts.v1.Google
 */
export interface Google {
}
/**
 * @generated from protobuf message c1.api.accounts.v1.Microsoft
 */
export interface Microsoft {
}
/**
 * @generated from protobuf message c1.api.accounts.v1.Okta
 */
export interface Okta {
    /**
     * @generated from protobuf field: string domain = 1;
     */
    domain: string;
    /**
     * @generated from protobuf field: string oidc_client_id = 3;
     */
    oidcClientId: string;
    /**
     * @generated from protobuf field: string oidc_client_secret = 4;
     */
    oidcClientSecret: string;
}
/**
 * @generated from protobuf message c1.api.accounts.v1.OneLogin
 */
export interface OneLogin {
    /**
     * @generated from protobuf field: string domain = 1;
     */
    domain: string;
    /**
     * @generated from protobuf field: string client_id = 2;
     */
    clientId: string;
    /**
     * @generated from protobuf field: string client_secret = 3;
     */
    clientSecret: string;
}
/**
 * @generated from protobuf message c1.api.accounts.v1.JumpCloud
 */
export interface JumpCloud {
    /**
     * @generated from protobuf field: string client_id = 1;
     */
    clientId: string;
    /**
     * @generated from protobuf field: string client_secret = 2;
     */
    clientSecret: string;
}
/**
 * @generated from protobuf message c1.api.accounts.v1.PingOne
 */
export interface PingOne {
    /**
     * @generated from protobuf field: string environment_id = 1;
     */
    environmentId: string;
    /**
     * @generated from protobuf field: string client_id = 2;
     */
    clientId: string;
    /**
     * @generated from protobuf field: string client_secret = 3;
     */
    clientSecret: string;
}
/**
 * @generated from protobuf message c1.api.accounts.v1.OIDC
 */
export interface OIDC {
    /**
     * @generated from protobuf field: string issuer_id = 1;
     */
    issuerId: string;
    /**
     * @generated from protobuf field: string client_id = 2;
     */
    clientId: string;
    /**
     * @generated from protobuf field: string client_secret = 3;
     */
    clientSecret: string;
    /**
     * @generated from protobuf field: repeated string scopes = 4;
     */
    scopes: string[];
    /**
     * @generated from protobuf field: map<string, string> exact_match_claims = 5;
     */
    exactMatchClaims: {
        [key: string]: string;
    };
}
/**
 * @generated from protobuf message c1.api.accounts.v1.AuthBackend
 */
export interface AuthBackend {
    /**
     * @generated from protobuf oneof: auth_backend
     */
    authBackend: {
        oneofKind: "google";
        /**
         * @generated from protobuf field: c1.api.accounts.v1.Google google = 100;
         */
        google: Google;
    } | {
        oneofKind: "microsoft";
        /**
         * @generated from protobuf field: c1.api.accounts.v1.Microsoft microsoft = 101;
         */
        microsoft: Microsoft;
    } | {
        oneofKind: "okta";
        /**
         * @generated from protobuf field: c1.api.accounts.v1.Okta okta = 102;
         */
        okta: Okta;
    } | {
        oneofKind: "oneLogin";
        /**
         * @generated from protobuf field: c1.api.accounts.v1.OneLogin one_login = 103;
         */
        oneLogin: OneLogin;
    } | {
        oneofKind: "jumpCloud";
        /**
         * @generated from protobuf field: c1.api.accounts.v1.JumpCloud jump_cloud = 104;
         */
        jumpCloud: JumpCloud;
    } | {
        oneofKind: "pingOne";
        /**
         * @generated from protobuf field: c1.api.accounts.v1.PingOne ping_one = 105;
         */
        pingOne: PingOne;
    } | {
        oneofKind: "oidc";
        /**
         * @generated from protobuf field: c1.api.accounts.v1.OIDC oidc = 106;
         */
        oidc: OIDC;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.accounts.v1.SignupRequest
 */
export interface SignupRequest {
    /**
     * @generated from protobuf field: string domain = 1;
     */
    domain: string;
    /**
     * @generated from protobuf field: string display_name = 2;
     */
    displayName: string;
    /**
     * @generated from protobuf field: string invite_code = 3;
     */
    inviteCode: string;
    /**
     * @generated from protobuf field: c1.api.accounts.v1.AuthBackend auth_backend = 4;
     */
    authBackend?: AuthBackend;
    /**
     * @generated from protobuf field: bool accepted_terms = 5;
     */
    acceptedTerms: boolean;
}
/**
 * @generated from protobuf message c1.api.accounts.v1.SignupResponse
 */
export interface SignupResponse {
    /**
     * @generated from protobuf field: string redirect_uri = 1;
     */
    redirectUri: string;
}
/**
 * @generated from protobuf message c1.api.accounts.v1.GetRUMRequest
 */
export interface GetRUMRequest {
}
/**
 * @generated from protobuf message c1.api.accounts.v1.GetRUMResponse
 */
export interface GetRUMResponse {
    /**
     * @generated from protobuf field: string datadog_rum_app_id = 1;
     */
    datadogRumAppId: string;
    /**
     * @generated from protobuf field: string datadog_rum_client_token = 2;
     */
    datadogRumClientToken: string;
    /**
     * @generated from protobuf field: string datadog_site = 3;
     */
    datadogSite: string;
    /**
     * @generated from protobuf field: string datadog_rum_env = 4;
     */
    datadogRumEnv: string;
}
/**
 * @generated from protobuf enum c1.api.accounts.v1.AuthBackends
 */
export enum AuthBackends {
    /**
     * @generated from protobuf enum value: AUTH_BACKEND_UNKNOWN = 0;
     */
    AUTH_BACKEND_UNKNOWN = 0,
    /**
     * @generated from protobuf enum value: AUTH_BACKEND_GOOGLE = 1;
     */
    AUTH_BACKEND_GOOGLE = 1,
    /**
     * @generated from protobuf enum value: AUTH_BACKEND_MICROSOFT = 2;
     */
    AUTH_BACKEND_MICROSOFT = 2,
    /**
     * @generated from protobuf enum value: AUTH_BACKEND_OKTA = 3;
     */
    AUTH_BACKEND_OKTA = 3,
    /**
     * @generated from protobuf enum value: AUTH_BACKEND_ONELOGIN = 4;
     */
    AUTH_BACKEND_ONELOGIN = 4,
    /**
     * @generated from protobuf enum value: AUTH_BACKEND_JUMPCLOUD = 5;
     */
    AUTH_BACKEND_JUMPCLOUD = 5,
    /**
     * @generated from protobuf enum value: AUTH_BACKEND_PINGONE = 6;
     */
    AUTH_BACKEND_PINGONE = 6,
    /**
     * @generated from protobuf enum value: AUTH_BACKEND_OIDC = 7;
     */
    AUTH_BACKEND_OIDC = 7
}
// @generated message type with reflection information, may provide speed optimized methods
class ListAuthBackendsRequest$Type extends MessageType<ListAuthBackendsRequest> {
    constructor() {
        super("c1.api.accounts.v1.ListAuthBackendsRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accounts.v1.ListAuthBackendsRequest
 */
export const ListAuthBackendsRequest = new ListAuthBackendsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAuthBackendsResponse$Type extends MessageType<ListAuthBackendsResponse> {
    constructor() {
        super("c1.api.accounts.v1.ListAuthBackendsResponse", [
            { no: 1, name: "auth_backends", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.accounts.v1.AuthBackends", AuthBackends] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accounts.v1.ListAuthBackendsResponse
 */
export const ListAuthBackendsResponse = new ListAuthBackendsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetInstallationRequest$Type extends MessageType<GetInstallationRequest> {
    constructor() {
        super("c1.api.accounts.v1.GetInstallationRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accounts.v1.GetInstallationRequest
 */
export const GetInstallationRequest = new GetInstallationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTenantRequest$Type extends MessageType<GetTenantRequest> {
    constructor() {
        super("c1.api.accounts.v1.GetTenantRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "254" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accounts.v1.GetTenantRequest
 */
export const GetTenantRequest = new GetTenantRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Installation$Type extends MessageType<Installation> {
    constructor() {
        super("c1.api.accounts.v1.Installation", [
            { no: 1, name: "domain", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "port", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "accounts_domain", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "accounts_port", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accounts.v1.Installation
 */
export const Installation = new Installation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Tenant$Type extends MessageType<Tenant> {
    constructor() {
        super("c1.api.accounts.v1.Tenant", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "domain", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "installation", kind: "message", T: () => Installation }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accounts.v1.Tenant
 */
export const Tenant = new Tenant$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Google$Type extends MessageType<Google> {
    constructor() {
        super("c1.api.accounts.v1.Google", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accounts.v1.Google
 */
export const Google = new Google$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Microsoft$Type extends MessageType<Microsoft> {
    constructor() {
        super("c1.api.accounts.v1.Microsoft", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accounts.v1.Microsoft
 */
export const Microsoft = new Microsoft$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Okta$Type extends MessageType<Okta> {
    constructor() {
        super("c1.api.accounts.v1.Okta", [
            { no: 1, name: "domain", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "300" } } } },
            { no: 3, name: "oidc_client_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "1024" } } } },
            { no: 4, name: "oidc_client_secret", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "4096" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accounts.v1.Okta
 */
export const Okta = new Okta$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OneLogin$Type extends MessageType<OneLogin> {
    constructor() {
        super("c1.api.accounts.v1.OneLogin", [
            { no: 1, name: "domain", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "300" } } } },
            { no: 2, name: "client_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "1024" } } } },
            { no: 3, name: "client_secret", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "4096" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accounts.v1.OneLogin
 */
export const OneLogin = new OneLogin$Type();
// @generated message type with reflection information, may provide speed optimized methods
class JumpCloud$Type extends MessageType<JumpCloud> {
    constructor() {
        super("c1.api.accounts.v1.JumpCloud", [
            { no: 1, name: "client_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "1024" } } } },
            { no: 2, name: "client_secret", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "4096" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accounts.v1.JumpCloud
 */
export const JumpCloud = new JumpCloud$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PingOne$Type extends MessageType<PingOne> {
    constructor() {
        super("c1.api.accounts.v1.PingOne", [
            { no: 1, name: "environment_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "1024" } } } },
            { no: 2, name: "client_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "1024" } } } },
            { no: 3, name: "client_secret", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "4096" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accounts.v1.PingOne
 */
export const PingOne = new PingOne$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OIDC$Type extends MessageType<OIDC> {
    constructor() {
        super("c1.api.accounts.v1.OIDC", [
            { no: 1, name: "issuer_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "1024" } } } },
            { no: 2, name: "client_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "1024" } } } },
            { no: 3, name: "client_secret", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "4096" } } } },
            { no: 4, name: "scopes", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "16", unique: true } } } },
            { no: 5, name: "exact_match_claims", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "validate.rules": { map: { maxPairs: "16", keys: { string: { minBytes: "3", maxBytes: "256" } }, values: { string: { minBytes: "3", maxBytes: "256" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accounts.v1.OIDC
 */
export const OIDC = new OIDC$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AuthBackend$Type extends MessageType<AuthBackend> {
    constructor() {
        super("c1.api.accounts.v1.AuthBackend", [
            { no: 100, name: "google", kind: "message", oneof: "authBackend", T: () => Google },
            { no: 101, name: "microsoft", kind: "message", oneof: "authBackend", T: () => Microsoft },
            { no: 102, name: "okta", kind: "message", oneof: "authBackend", T: () => Okta },
            { no: 103, name: "one_login", kind: "message", oneof: "authBackend", T: () => OneLogin },
            { no: 104, name: "jump_cloud", kind: "message", oneof: "authBackend", T: () => JumpCloud },
            { no: 105, name: "ping_one", kind: "message", oneof: "authBackend", T: () => PingOne },
            { no: 106, name: "oidc", kind: "message", oneof: "authBackend", T: () => OIDC }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accounts.v1.AuthBackend
 */
export const AuthBackend = new AuthBackend$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SignupRequest$Type extends MessageType<SignupRequest> {
    constructor() {
        super("c1.api.accounts.v1.SignupRequest", [
            { no: 1, name: "domain", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "63", hostname: true } } } },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "63" } } } },
            { no: 3, name: "invite_code", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9-]{8,64}$" } } } },
            { no: 4, name: "auth_backend", kind: "message", T: () => AuthBackend, options: { "validate.rules": { message: { required: true } } } },
            { no: 5, name: "accepted_terms", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accounts.v1.SignupRequest
 */
export const SignupRequest = new SignupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SignupResponse$Type extends MessageType<SignupResponse> {
    constructor() {
        super("c1.api.accounts.v1.SignupResponse", [
            { no: 1, name: "redirect_uri", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accounts.v1.SignupResponse
 */
export const SignupResponse = new SignupResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRUMRequest$Type extends MessageType<GetRUMRequest> {
    constructor() {
        super("c1.api.accounts.v1.GetRUMRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accounts.v1.GetRUMRequest
 */
export const GetRUMRequest = new GetRUMRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRUMResponse$Type extends MessageType<GetRUMResponse> {
    constructor() {
        super("c1.api.accounts.v1.GetRUMResponse", [
            { no: 1, name: "datadog_rum_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "datadog_rum_client_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "datadog_site", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "datadog_rum_env", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accounts.v1.GetRUMResponse
 */
export const GetRUMResponse = new GetRUMResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.accounts.v1.Accounts
 */
export const Accounts = new ServiceType("c1.api.accounts.v1.Accounts", [
    { name: "ListAuthBackends", options: {}, I: ListAuthBackendsRequest, O: ListAuthBackendsResponse },
    { name: "GetInstallation", options: {}, I: GetInstallationRequest, O: Installation },
    { name: "GetTenant", options: {}, I: GetTenantRequest, O: Tenant },
    { name: "Signup", options: {}, I: SignupRequest, O: SignupResponse },
    { name: "GetRUM", options: {}, I: GetRUMRequest, O: GetRUMResponse }
], { "authz.service": { disabled: true } });
